import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Component } from 'react';
import Textfield from "@scentregroup/ui/components/form/textfield";
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
class SearchField extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "handleSubmit", event => {
      event.preventDefault();
      // Trigger blur event to dismiss the Keyboard when user clicks Search in iOS.
      window.document.activeElement.blur();
    });
  }
  render() {
    return /*#__PURE__*/_jsx("form", {
      action: "#" // Show Search button in iOS
      ,
      onSubmit: this.handleSubmit,
      "data-id": "search-field_index_form",
      children: /*#__PURE__*/_jsx(Textfield, _objectSpread(_objectSpread({
        type: "search",
        classNames: style
      }, this.props), {}, {
        "data-id": "search-field_index_form_Textfield"
      }))
    });
  }
}
export default SearchField;